import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { ChevronDown, ChevronUp, Plus, Trash2 } from 'lucide-react'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { FieldProps } from 'app/frontend/base/components/form-fields/types'

interface CustomLink {
  label: string
  url: string
}

const CustomLinksField = ({ name }: FieldProps<unknown>) => {
  const { register, watch } = useFormContext()
  const { fields, append, remove, move } = useFieldArray({ name })

  const links: CustomLink[] = watch(name) ?? []

  return (
    <div className='space-y-1'>
      <Label>Links</Label>

      {fields.length === 0 && (
        <p className='text-sm text-muted-foreground'>No links added yet.</p>
      )}

      {fields.map((field, index) => (
        <div key={field.id} className='flex items-center gap-2'>
          <Input
            {...register(`${name}.${index}.label`)}
            placeholder='Label'
            className='flex-1'
          />
          <Input
            {...register(`${name}.${index}.url`)}
            placeholder='URL'
            className='flex-2'
          />
          <Button
            type='button'
            size='sm'
            variant='outline'
            disabled={index === 0}
            onClick={() => move(index, index - 1)}
            className='h-8 w-8 p-0'
          >
            <ChevronUp size={14} />
          </Button>
          <Button
            type='button'
            size='sm'
            variant='outline'
            disabled={index === links.length - 1}
            onClick={() => move(index, index + 1)}
            className='h-8 w-8 p-0'
          >
            <ChevronDown size={14} />
          </Button>
          <Button
            type='button'
            size='sm'
            variant='outline'
            onClick={() => remove(index)}
            className='h-8 w-8 p-0'
          >
            <Trash2 size={14} className='text-muted-foreground' />
          </Button>
        </div>
      ))}

      <Button
        type='button'
        size='sm'
        variant='outline'
        onClick={() => append({ label: '', url: '' })}
      >
        <Plus size={14} className='mr-1' />
        Add link
      </Button>
    </div>
  )
}

export default CustomLinksField
